import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const SkypeIcon = ({ color, viewBox, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      d="M17.3654 10.4773C17.4577 9.97098 17.5072 9.45342 17.5072 8.93585C17.5072 7.78821 17.2821 6.67432 16.8388 5.62794C16.4113 4.61532 15.797 3.70621 15.0161 2.92536C14.2418 2.14907 13.3239 1.53076 12.3135 1.10489C11.2649 0.661582 10.1533 0.436554 9.00562 0.436554C8.46556 0.436554 7.92324 0.48831 7.39668 0.589573C6.66807 0.203477 5.85622 0.00109407 5.03163 0C3.68822 0 2.42356 0.524315 1.47395 1.47393C1.00535 1.94012 0.633822 2.49457 0.380829 3.10522C0.127837 3.71588 -0.00159538 4.37063 1.48412e-05 5.03162C1.48412e-05 5.88673 0.220542 6.72833 0.632343 7.47092C0.549083 7.95248 0.504077 8.44529 0.504077 8.93585C0.504077 10.0835 0.729105 11.1974 1.17241 12.2438C1.59996 13.2564 2.21204 14.1655 2.99288 14.9463C3.77373 15.7272 4.68284 16.3393 5.69547 16.7668C6.7441 17.2101 7.85573 17.4351 9.00337 17.4351C9.50294 17.4351 10.0025 17.3901 10.4931 17.3024C11.2469 17.7277 12.0975 17.955 12.9684 17.955C14.3118 17.955 15.5764 17.4329 16.5261 16.481C17.4779 15.5314 18 14.2668 18 12.9233C18.0022 12.0682 17.7817 11.2244 17.3654 10.4773ZM9.03938 14.143C6.01951 14.143 4.66934 12.6578 4.66934 11.5462C4.66934 10.9746 5.09014 10.5763 5.67071 10.5763C6.96237 10.5763 6.62933 12.4328 9.03938 12.4328C10.2748 12.4328 10.9566 11.7622 10.9566 11.0759C10.9566 10.6641 10.7541 10.205 9.93949 10.0047L7.25266 9.33415C5.09014 8.79183 4.69634 7.62169 4.69634 6.52355C4.69634 4.24177 6.84536 3.38442 8.86386 3.38442C10.7226 3.38442 12.9144 4.41279 12.9144 5.78096C12.9144 6.36829 12.4058 6.70808 11.8252 6.70808C10.7226 6.70808 10.9251 5.18239 8.70409 5.18239C7.60145 5.18239 6.99163 5.68195 6.99163 6.39529C6.99163 7.10863 7.86248 7.3359 8.61858 7.50918L10.6078 7.95023C12.7861 8.43629 13.3374 9.7077 13.3374 10.9048C13.3374 12.7568 11.913 14.143 9.03938 14.143V14.143Z"
      fill={color}
    />
  </svg>
);

SkypeIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

SkypeIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(18, 18),
  ...helpers.getViewBoxProperty({ width: 18, height: 18 }),
};

export default SkypeIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/skype.js